
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AthleteMetric } from '@/../types/enums';
import { VuetifyMixin } from '../../../mixins';
import AssessmentDataInfoProvider from '../../hoc/AssessmentDataInfoProvider.vue';
import ExpandingCard from '../../ui/ExpandingCard.vue';

import RulerSvg from '../../svg/RulerSvg.vue';
import SpeedometerSvg from '../../svg/SpeedometerSvg.vue';
import StopwatchSvg from '../../svg/StopwatchSvg.vue';
import LightningSvg from '../../svg/LightningSvg.vue';
import AgilitySvg from '../../svg/AgilitySvg.vue';
import HeartVitalSvg from '../../svg/HeartVitalSvg.vue';
import { SelfAssessmentModel } from '../../../models/athlete/SelfAssessmentModel';


@Component({
	components: {
		AssessmentDataInfoProvider,
		ExpandingCard,

		RulerSvg,
		SpeedometerSvg,
		StopwatchSvg,
		LightningSvg,
		AgilitySvg,
		HeartVitalSvg,
	}
})
export default class AthleteSelfAssessmentStatCard extends Mixins(VuetifyMixin){
	@Prop({ required: true }) metric: AthleteMetric;
	@Prop({ required: true }) selfAssessment: SelfAssessmentModel;
	@Prop({ type: Boolean, default: false }) loading: boolean;
	@Prop({ type: Number, default: '100%' }) height: string;
	@Prop({ type: Boolean, default: true }) loadData: boolean;

	get RootStyle(): Record<string,any>{
		return {
			'height': this.height,
			'flex-basis': '300px',
		};
	}
}
